export interface AdformOAuthStatePayload {
  connectionId: string;
  integrationName: string;
}

export function encodeAdFormOAuthStatePayload(
  payload: AdformOAuthStatePayload,
): string {
  return globalThis.btoa(
    Array.from(new TextEncoder().encode(JSON.stringify(payload)), (byte) =>
      String.fromCodePoint(byte),
    ).join(''),
  );
}

export function parseAdFormOAuthState(stateParam?: string): null | {
  integrationName?: string;
  connectionId?: string;
} {
  if (!stateParam) {
    return null;
  }

  const separatorIndex = stateParam.indexOf('.');

  if (separatorIndex === -1) {
    return null;
  }

  const encodedPayload = stateParam.slice(separatorIndex + 1);

  if (!encodedPayload) {
    return null;
  }

  try {
    const decodedPayload = new TextDecoder().decode(
      Uint8Array.from(globalThis.atob(encodedPayload), (char) => {
        const codePoint = char.codePointAt(0);

        if (codePoint === undefined) {
          throw new Error('Expected a base64-decoded character.');
        }

        return codePoint;
      }),
    );

    return JSON.parse(decodedPayload) as AdformOAuthStatePayload;
  } catch {
    // TODO: remove legacy state parsing once the old state format is no longer used (after one day in PROD)
    const legacyStateParts = stateParam.split('.');

    return {
      connectionId: legacyStateParts[3],
      integrationName: legacyStateParts[1],
    };
  }
}
